﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';
import TKFilter, { FilterItem } from '@tk/components/tk.filter';

export default class TKFilterChip extends TKCustomElementFactory {
    chip?: HTMLButtonElement;
    tkFilter?: TKFilter;
    filterItem?: FilterItem;

    constructor() {
        super();

        this.chip = this.querySelector('[data-tk-filter-chip-remove]') || undefined;
        this.tkFilter = this.closest('tk-filter') || undefined;
    }

    connectedCallback(): void {
        if (
            !this.chip
            || !this.dataset.tkFilterChipId
            || !this.dataset.tkFilterChipAttribute
            || !this.dataset.tkFilterChipValue
        ) return;
        this.filterItem = {
            id: this.dataset.tkFilterChipId,
            attr: this.dataset.tkFilterChipAttribute,
            value: this.dataset.tkFilterChipValue,
        };
        this.registerClickListener();
        this.registerFilterListener();
    }

    registerClickListener(): void {
        const handleRemoveChip = this.removeFilterItem.bind(this);
        this.pushListener({ event: 'click', element: this.chip!, action: handleRemoveChip });
    }

    registerFilterListener(): void {
        this.tkFilter?.subscribe((data) => {
            if (data.action === 'REFRESHED') {
                if (!this.tkFilter?.exist(this.filterItem!)) this.remove();
            }
        });
    }

    removeFilterItem() {
        this.tkFilter?.delete(this.filterItem!);
        this.tkFilter?.post();
    }
}